import Hotel from "./Hotel";

export default Hotel;
